import React from "react";
import { Check } from "../../../styled/create";

const ListMember = ({ mber, handleSelect, chkMbers, clickButton }) => {
  return (
    <li key={mber.mberNo}>
      <div>
        <Check>
          <input
            type="checkbox"
            checked={chkMbers[mber.mberNo] || false}
            onChange={() => handleSelect(mber.mberNo)}
          />
        </Check>
      </div>
      <div>{mber.nickNm ? mber.nickNm : "닉네임 미설정"}</div>
      <div>
        <button onClick={() => clickButton([mber], true)}>수락</button>
        <button onClick={() => clickButton([mber], false)}>거절</button>
      </div>
    </li>
  );
};

export default ListMember;
